<div class="loadingg"><span *ngIf="loading"><mat-spinner></mat-spinner></span></div>
<div>
  <mat-card-title>
    <label class="mat-h2 bold">MEUS FILTROS</label>
  </mat-card-title>
</div>

<mat-tab-group [selectedIndex]="selectedTab">
  <mat-tab label="Filtros Criados">
    <mat-progress-bar *ngIf="loadListaFiltros" class="progress-bar" mode="indeterminate"></mat-progress-bar>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort style="width:100%;">
        <ng-container matColumnDef="nomeFiltro">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome Filtro </th>
          <td mat-cell *matCellDef="let element"> {{element.nomeFiltro}} </td>
        </ng-container>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-button (click)="EditarFiltro(element.idFiltro, element.nomeFiltro)" color="warn"><mat-icon>edit</mat-icon></button>
            <button mat-button (click)="deleteFiltro(element)" color="warn"><mat-icon>delete</mat-icon></button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
  </mat-tab>

  <mat-tab label="Criar Filtro">
    <form [formGroup]="FiltroForm" class="expansion-panel">
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="100%">
          <input matInput formControlName="frmNomeFiltro" required placeholder="Nome Filtro">
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="48%">
          <input matInput formControlName="frmUsuarioCriacao" required placeholder="Usuário Criação">
        </mat-form-field>
        <mat-form-field fxFlex="48%">
          <mat-select formControlName="frmResponsavel" required placeholder="Responsável">
            <mat-option *ngFor="let responsavel of responsaveis" [value]="responsavel.login">
              {{responsavel.nome}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <a mat-button color="primary" class="btn-primary" (click)="AdicinarItem()">Adicionar</a>
        </div>
      </div>
      <div class="table-container">
        <table mat-table [dataSource]="dataSourceCriar" matSortCriar style="width:100%;">
          <ng-container matColumnDef="usuarioCriacao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Usuário Criação </th>
            <td mat-cell *matCellDef="let element"> {{element.usuarioCriacao}} </td>
          </ng-container>
          <ng-container matColumnDef="responsavel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsavel </th>
            <td mat-cell *matCellDef="let element"> {{element.responsavel}} </td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row">
              <button mat-button (click)="deleteRowCriar(row)" color="warn"><mat-icon>delete</mat-icon></button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsCriar"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsCriar;"></tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
      <mat-action-row class="footer">
        <a mat-button color="primary" class="btn-primary" (click)="Salvar()">Salvar</a>
      </mat-action-row>
    </form>
  </mat-tab>

  <mat-tab [disabled]="disabledYN" id="tabEdit" label="Editar">
    <mat-progress-bar *ngIf="loadListaFiltrosEdit" class="progress-bar" mode="indeterminate"></mat-progress-bar>
    <form [formGroup]="FiltroEditForm" class="expansion-panel">
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="100%">
          <input matInput formControlName="frmNomeFiltroEdit" required placeholder="Nome Filtro">
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="48%">
          <input matInput formControlName="frmUsuarioCriacaoEdit" required placeholder="Usuário Criação">
        </mat-form-field>
        <mat-form-field fxFlex="48%">
          <mat-select formControlName="frmResponsavelEdit" required placeholder="Responsável">
            <mat-option *ngFor="let responsavel of responsaveis" [value]="responsavel.login">
              {{responsavel.nome}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <a mat-button color="primary" class="btn-primary" (click)="AdicinarItemEdit()">Adicionar</a>
        </div>
      </div>
      <div class="table-container">
        <table mat-table [dataSource]="dataSourceEdit" matSortEdit style="width:100%;">
          <ng-container matColumnDef="usuarioCriacao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Usuário Criação </th>
            <td mat-cell *matCellDef="let element"> {{element.usuarioCriacao}} </td>
          </ng-container>
          <ng-container matColumnDef="responsavel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsavel </th>
            <td mat-cell *matCellDef="let element"> {{element.responsavel}} </td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row">
              <button mat-button (click)="deleteRowEdicao(row)" color="warn"><mat-icon>delete</mat-icon></button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsEdit"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsEdit;"></tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
      <mat-action-row class="footer">
        <a mat-button color="primary" class="btn-primary" (click)="Editar()">Editar</a>
      </mat-action-row>
    </form>
  </mat-tab>
</mat-tab-group>

<mat-action-row class="footer">
  <button mat-button color="warn" (click)="closePopup()" matTooltip="Caso não concorde os dados preenchidos neste formulário serão perdidos">Cancelar</button>
</mat-action-row>